module.exports = __webpack_public_path__ + "static/apple-icon-152x152-f83c714af08124a590f68543d6768531.png";